export default __webpack_public_path__ + "static/media/sitemap.fcc30a1b.jpg";